var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "truck-summary", style: _vm.containerHeight },
    [
      _c(
        "el-row",
        { attrs: { type: "flex", gutter: 8 } },
        [
          _c(
            "el-col",
            { attrs: { id: "sectionTitle" } },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    "label-position": "top",
                    "label-width": "8em",
                    inline: true,
                    size: "mini",
                  },
                },
                [
                  _c("el-form-item", { staticClass: "w-100" }, [
                    _c(
                      "h3",
                      {
                        staticClass:
                          "mt-0 mb-0 text-center d-inline-block w-100",
                      },
                      [
                        !_vm.helper.isUndefined(_vm.truckInPlan) &&
                        _vm.truckInPlan.orderId &&
                        _vm.truckInPlan.orderId.length > 0
                          ? _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  placement: "top",
                                  "popper-options": _vm.popperOptions,
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    attrs: { slot: "content" },
                                    slot: "content",
                                  },
                                  [
                                    _c("div", [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("general.totalOrders")
                                          ) + ":"
                                        ),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.truckInPlan.orderId
                                              ? _vm.truckInPlan.orderId.length
                                              : 0
                                          )
                                      ),
                                    ]),
                                    _c("div", [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("planning.columns.planId")
                                          ) + ": "
                                        ),
                                      ]),
                                      _vm._v(
                                        _vm._s(
                                          _vm.truckInPlan.planId.join(", ")
                                        )
                                      ),
                                    ]),
                                    _c("div", [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("planning.tooltip.shipRefs")
                                          ) + ":"
                                        ),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm
                                              .getShipRefsFromOrderId(
                                                _vm.truckInPlan.orderId
                                              )
                                              .join(", ")
                                          )
                                      ),
                                    ]),
                                  ]
                                ),
                                _c("font-awesome-icon", {
                                  staticClass: "d-none d-md-inline",
                                  attrs: { icon: "info-circle" },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(
                          " " + _vm._s(_vm.currentTruck.plateNumber) + " "
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            {
              staticClass: "d-none d-md-block",
              attrs: { id: "sectionFunction" },
            },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    "label-position": "top",
                    "label-width": "8em",
                    inline: true,
                    size: "mini",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { staticClass: "w-100" },
                    [
                      _c("el-input", {
                        attrs: {
                          clearable: "",
                          size: "mini",
                          placeholder: _vm.$t(
                            "planning.placeholder.searchRouteByShipRef"
                          ),
                          disabled:
                            _vm.helper.isEmpty(_vm.searchText) &&
                            _vm.routes.length === 0,
                        },
                        on: { input: _vm.handleSearchShipRef },
                        model: {
                          value: _vm.searchText,
                          callback: function ($$v) {
                            _vm.searchText = $$v
                          },
                          expression: "searchText",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            {
              staticClass: "d-none d-md-block",
              attrs: { id: "sectionUtilities" },
            },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    "label-position": "top",
                    "label-width": "8em",
                    inline: true,
                    size: "mini",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            size: "mini",
                            disabled:
                              _vm.truckPlanIds && _vm.truckPlanIds.length === 0,
                            filterable: "",
                            placeholder: _vm.$t(
                              "planning.placeholder.printPlanId"
                            ),
                          },
                          model: {
                            value: _vm.currentPlanId,
                            callback: function ($$v) {
                              _vm.currentPlanId = $$v
                            },
                            expression: "currentPlanId",
                          },
                        },
                        _vm._l(_vm.truckPlanIds, function (planId) {
                          return _c("el-option", {
                            key: planId,
                            attrs: { label: planId, value: planId },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: _vm.$t("planning.printPlanId"),
                            placement: "top",
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "disabled-btn-wrapper" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    disabled:
                                      (_vm.truckPlanIds &&
                                        (_vm.truckPlanIds.length === 0 ||
                                          _vm.currentPlanId === null)) ||
                                      _vm.isManualAssignLoading,
                                    type: "success",
                                    size: "mini",
                                  },
                                  on: { click: _vm.printPlanId },
                                },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "print", size: "lg" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            disabled:
                              _vm.helper.isUndefined(_vm.$selectedTruck) ||
                              _vm.isDriverSelectionDisabled ||
                              _vm.isPlanIdBelongToDifferentUser(
                                _vm.currentPlanId
                              ),
                            filterable: "",
                            placeholder: _vm.$t(
                              "planning.placeholder.searchDriver"
                            ),
                          },
                          on: { change: _vm.handleCurrentDriverChanges },
                          model: {
                            value: _vm.currentDriver,
                            callback: function ($$v) {
                              _vm.currentDriver = $$v
                            },
                            expression: "currentDriver",
                          },
                        },
                        _vm._l(_vm.driversList, function (driver) {
                          return _c(
                            "el-option",
                            {
                              key: driver.RecId,
                              attrs: {
                                disabled: _vm.blockedDrivers.includes(
                                  driver.RecId
                                ),
                                label:
                                  driver.UserName +
                                  " [" +
                                  driver.Carplate +
                                  "] ",
                                value: driver.RecId,
                              },
                            },
                            [
                              _c("span", { staticStyle: { float: "left" } }, [
                                _vm._v(
                                  _vm._s(driver.UserName) +
                                    " [" +
                                    _vm._s(driver.Carplate) +
                                    "] "
                                ),
                              ]),
                              driver.UserName
                                ? _c(
                                    "span",
                                    { staticStyle: { float: "right" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          "" +
                                            (driver["MonitorType"] === "M"
                                              ? _vm.$t("planning.mobile")
                                              : _vm.$t("planning.noMonitor"))
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: _vm.$t("planning.assignToDriver"),
                            placement: "top",
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "disabled-btn-wrapper" },
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: {
                                    padding: "5px 13px !important",
                                  },
                                  attrs: {
                                    type: "success",
                                    disabled:
                                      _vm.isAssignDriverDisabled ||
                                      _vm.isManualAssignLoading ||
                                      _vm.isPlanIdBelongToDifferentUser(
                                        _vm.currentPlanId
                                      ),
                                    size: "mini",
                                  },
                                  on: { click: _vm.assignToDriver },
                                },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: {
                                      icon: "people-carry",
                                      "aria-hidden": "true",
                                      size: "lg",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.isPlanIdBelongToDifferentUser(_vm.currentPlanId)
            ? _c(
                "el-col",
                { staticStyle: { margin: "4px 22px" } },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: ["far", "eye"], size: "lg" },
                  }),
                  _c("span", { staticClass: "ml-2" }, [
                    _c("i", [_vm._v(_vm._s(_vm.$t("planning.viewOnly")))]),
                    _c("b", { staticClass: "ml-1" }, [
                      _vm._v("- " + _vm._s(_vm.$t("general.createdBy")) + ":"),
                    ]),
                    _vm._v(" " + _vm._s(_vm.getUsername()) + " "),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-col",
            [
              _c(
                "draggable",
                _vm._b(
                  {
                    staticClass: "list-group",
                    style: { height: _vm.listHeight },
                    attrs: { disabled: true, tag: "ul" },
                    on: {
                      update: function ($event) {
                        _vm.$anyChanges = true
                      },
                    },
                    model: {
                      value: _vm.routes,
                      callback: function ($$v) {
                        _vm.routes = $$v
                      },
                      expression: "routes",
                    },
                  },
                  "draggable",
                  _vm.dragOptions,
                  false
                ),
                [
                  _c(
                    "transition-group",
                    { attrs: { type: "transition", name: "flip-list" } },
                    _vm._l(_vm.routes, function (route, routeIndex) {
                      return _c(
                        "li",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isRouteVisible(route),
                              expression: "isRouteVisible(route)",
                            },
                          ],
                          key: "" + route.masterpointId,
                          staticClass: "list-group-item",
                          class: _vm.getRouteClass(route),
                          style: _vm.getRouteStyles(route),
                          on: {
                            click: function ($event) {
                              return _vm.onRouteClick(routeIndex)
                            },
                          },
                        },
                        [
                          _c(
                            "el-row",
                            { attrs: { type: "flex" } },
                            [
                              _c(
                                "el-col",
                                { staticStyle: { width: "45px" } },
                                [
                                  _c("span", { staticClass: "point-index" }, [
                                    _vm._v(_vm._s(routeIndex + 1)),
                                  ]),
                                  route.waypointType === "P"
                                    ? _c("font-awesome-icon", {
                                        staticClass: "point-type",
                                        staticStyle: {
                                          "margin-left": "13.5px",
                                        },
                                        attrs: {
                                          icon: "circle",
                                          "aria-hidden": "true",
                                          size: "lg",
                                        },
                                      })
                                    : _vm._e(),
                                  route.waypointType === "D"
                                    ? _c("font-awesome-icon", {
                                        staticClass: "point-type",
                                        staticStyle: { "margin-left": "16px" },
                                        attrs: {
                                          icon: "map-marker",
                                          "aria-hidden": "true",
                                          size: "lg",
                                        },
                                      })
                                    : _vm._e(),
                                  route.waypointType === "T"
                                    ? _c("font-awesome-icon", {
                                        staticClass: "point-type",
                                        staticStyle: {
                                          "margin-left": "13.5px",
                                        },
                                        attrs: {
                                          icon: ["far", "dot-circle"],
                                          "aria-hidden": "true",
                                          size: "lg",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { staticClass: "route-container" },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "align-top" },
                                    [
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content: _vm.$t("general.new"),
                                            placement: "top",
                                          },
                                        },
                                        [
                                          route.new
                                            ? _c("font-awesome-icon", {
                                                attrs: { icon: "bell" },
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            placement: "top",
                                            "popper-options": _vm.popperOptions,
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "content" },
                                              slot: "content",
                                            },
                                            [
                                              _c("div", [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "planning.columns.status"
                                                      )
                                                    ) + ": "
                                                  ),
                                                ]),
                                                _vm._v(_vm._s(route.status)),
                                              ]),
                                              _c("div", [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "planning.gMap.waypointType"
                                                      )
                                                    ) + ":"
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "planning.waypointType." +
                                                          route.waypointType
                                                      )
                                                    )
                                                ),
                                              ]),
                                              _c("div", [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "planning.columns.zone"
                                                      )
                                                    ) + ": "
                                                  ),
                                                ]),
                                                _vm._v(
                                                  _vm._s(
                                                    route.zone === ""
                                                      ? "-"
                                                      : route.zone
                                                  )
                                                ),
                                              ]),
                                              _c("div", [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "planning.gMap.district"
                                                      )
                                                    ) + ":"
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      route.district === ""
                                                        ? "-"
                                                        : route.district
                                                    )
                                                ),
                                              ]),
                                              _c("div", [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "planning.tooltip.address"
                                                      )
                                                    ) + ":"
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.getWaypointFromId(
                                                        route.masterpointId,
                                                        "address1"
                                                      )
                                                    )
                                                ),
                                              ]),
                                              _c("div", [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "general.createdBy"
                                                      )
                                                    ) + ":"
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      !_vm.helper.isUndefined(
                                                        route.createdUser
                                                      )
                                                        ? route.createdUser
                                                        : _vm.$userInformation
                                                            .user.name
                                                    )
                                                ),
                                              ]),
                                              _c("div", [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "planning.tooltip.companyName"
                                                      )
                                                    ) + ":"
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.getWaypointFromId(
                                                        route.masterpointId,
                                                        "companyName"
                                                      )
                                                    )
                                                ),
                                              ]),
                                              _c("hr"),
                                              _c("div", [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "planning.tooltip.startTravelling"
                                                      )
                                                    ) + ":"
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f("convertTimezone")(
                                                        route.startTime,
                                                        _vm.$timezone
                                                      )
                                                    )
                                                ),
                                              ]),
                                              _c("div", [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "planning.tooltip.start"
                                                      )
                                                    ) + ":"
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f("convertTimezone")(
                                                        route.estimateTime,
                                                        _vm.$timezone
                                                      )
                                                    )
                                                ),
                                              ]),
                                              _c("div", [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "planning.tooltip.end"
                                                      )
                                                    ) + ":"
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f("convertTimezone")(
                                                        route.endTime,
                                                        _vm.$timezone
                                                      )
                                                    )
                                                ),
                                              ]),
                                              _c("div", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "planning.tooltip.actualFinishDate"
                                                      )
                                                    ) +
                                                    ": "
                                                ),
                                                _vm.getWaypointFromId(
                                                  route.masterpointId,
                                                  "completedTime"
                                                ) === "0000-00-00 00:00:00"
                                                  ? _c("span", [_vm._v(" - ")])
                                                  : _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "convertTimezone"
                                                          )(
                                                            _vm.getWaypointFromId(
                                                              route.masterpointId,
                                                              "completedTime"
                                                            ),
                                                            _vm.$timezone
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                              ]),
                                              _c("hr"),
                                              _c("div", [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "planning.columns.planId"
                                                      )
                                                    ) + ":"
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " + _vm._s(route.planId)
                                                ),
                                              ]),
                                              _c("div", [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "planning.columns.projectCode"
                                                      )
                                                    ) + ":"
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.getOrderField(
                                                        _vm.getOrderId(route),
                                                        "projectCode"
                                                      )
                                                    )
                                                ),
                                              ]),
                                              _c("div", [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "planning.columns.customerCode"
                                                      )
                                                    ) + ":"
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.getOrderField(
                                                        _vm.getOrderId(route),
                                                        "customerCode"
                                                      )
                                                    )
                                                ),
                                              ]),
                                              _c("div", [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "planning.columns.shipmentReference"
                                                      )
                                                    ) + ":"
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      route.shipmentReference
                                                        ? route.shipmentReference.join(
                                                            ", "
                                                          )
                                                        : ""
                                                    )
                                                ),
                                              ]),
                                              _c("div", [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "planning.tooltip.qty"
                                                      )
                                                    ) + ":"
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.getOrderField(
                                                        _vm.getOrderId(route),
                                                        "quantity"
                                                      )
                                                    )
                                                ),
                                              ]),
                                              _c("div", [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "planning.tooltip.gw"
                                                      )
                                                    ) + ":"
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.getOrderField(
                                                        _vm.getOrderId(route),
                                                        "weight"
                                                      )
                                                    )
                                                ),
                                              ]),
                                              _c("div", [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "planning.tooltip.cbm"
                                                      )
                                                    ) + ":"
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.getOrderField(
                                                        _vm.getOrderId(route),
                                                        "volume"
                                                      )
                                                    )
                                                ),
                                              ]),
                                              _c("div", [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "planning.tooltip.serviceType"
                                                      )
                                                    ) + ":"
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.getOrderField(
                                                        _vm.getOrderId(route),
                                                        "serviceType"
                                                      )
                                                    )
                                                ),
                                              ]),
                                              _c("div", [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "planning.tooltip.commodityType"
                                                      )
                                                    ) + ":"
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.getOrderField(
                                                        _vm.getOrderId(route),
                                                        "commodityType"
                                                      )
                                                    )
                                                ),
                                              ]),
                                              _c("div", [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "planning.tooltip.remarks"
                                                      )
                                                    ) + ":"
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.getOrderField(
                                                        _vm.getOrderId(route),
                                                        "remarks"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _c("font-awesome-icon", {
                                            staticClass: "d-none d-md-inline",
                                            attrs: { icon: "info-circle" },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content: _vm.$t(
                                              "jobOrder.status.assigned"
                                            ),
                                            placement: "top",
                                          },
                                        },
                                        [
                                          route.status === "assigned"
                                            ? _c("font-awesome-icon", {
                                                attrs: { icon: "user" },
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "break-word d-inline-block display-address",
                                      class: { "ml-1": !_vm.$isMobile },
                                      style: _vm.getAddressStyle(route),
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(route.displayAddress) + " "
                                      ),
                                    ]
                                  ),
                                  !_vm.isRouteBelongToDifferentUser(route)
                                    ? _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content: _vm.$t(
                                              "planning.deleteRoutesByOrderId"
                                            ),
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "float-right cursor-pointer d-none d-md-inline-block",
                                              staticStyle: {
                                                "margin-left": "8px",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deleteRoute(route)
                                                },
                                              },
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                staticClass: "trash-icon",
                                                attrs: {
                                                  icon: "trash",
                                                  "aria-hidden": "true",
                                                  size: "sm",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "position-relative",
                                      staticStyle: { top: "-8px" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { class: _vm.isRouteLate(route) },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("planning.tooltip.eta")
                                            ) +
                                              ": " +
                                              _vm._s(
                                                _vm._f("convertTimezone")(
                                                  route.estimateTime,
                                                  _vm.$timezone
                                                )
                                              )
                                          ),
                                        ]
                                      ),
                                      _c("div", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "planning.tooltip.actualFinishDate"
                                              )
                                            ) +
                                            ": "
                                        ),
                                        _vm.getWaypointFromId(
                                          route.masterpointId,
                                          "completedTime"
                                        ) === "0000-00-00 00:00:00"
                                          ? _c("span", [_vm._v(" - ")])
                                          : _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("convertTimezone")(
                                                    _vm.getWaypointFromId(
                                                      route.masterpointId,
                                                      "completedTime"
                                                    ),
                                                    _vm.$timezone
                                                  )
                                                )
                                              ),
                                            ]),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }